import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import crossImage from '../../../assets/images/across.png';
import Button from '../../components/button';
import Modal from '../../containers/modal';
import { getLeftArrowImage } from '../../utils/imageChanges';
// import addImage from '../../../assets/images/plus.png';
import Select from 'react-select';
import { getOutletData } from '../../burger-king-lib/redux/home/actions';
import Loader from '../../components/loader-backdrop';
import Upload from '../../components/upload';
import './index.scss';

const FeedbackLatest = ({
  closeMe,
  values,
  progressLoader,
  setValues,
  handleFileChange,
  onDelete,
  handleSubmit
}) => {
  const dispatch = useDispatch();
  const outlets = useSelector(state => state?.home?.outletData?.content);
  // console.log(values, ' outlets ');
  const theme = 'takeaway';

  const filteredArr =
    outlets?.length > 0 &&
    outlets?.map(item => ({
      label: item.outlet_name,
      value: item.outlet_id
    }));

  React.useEffect(() => {
    dispatch(getOutletData());
  }, []);

  const renderContent = closeMe => (
    <div className={`feedback-form ${theme}`}>
      <div className="feedback-form_fullContent">
        {progressLoader ? <Loader fitContent={'true'} theme={theme} /> : ''}
        <div className="feedback-form_header">
          <div className="closeBtn">
            <div>
              <img
                onClick={() => {
                  closeMe();
                }}
                src={getLeftArrowImage()}
                alt="back buttn"
                className="butn"
              />
            </div>
            <div className="feedback-form__title">Feedback Form</div>
            <div />
          </div>
        </div>
        {!values.show ? (
          <>
            {' '}
            <div className="feedback-container">
              <div className="divide">
                <div className="divide partOne">
                  <input
                    type="text"
                    className="inputStyles partTwo"
                    placeholder="First Name *"
                    name="firstName"
                    onChange={e => setValues(e)}
                    value={values.firstName}
                  />
                </div>
                <div className="divide partOne">
                  <input
                    type="text"
                    className="inputStyles partTwo"
                    placeholder="Last Name *"
                    name="lastName"
                    onChange={e => setValues(e)}
                    value={values.lastName}
                  />
                </div>
              </div>

              <div className="divide">
                <div className="divide partOne">
                  <input
                    type="email"
                    className="inputStyles partTwo"
                    placeholder="Email Id *"
                    name="email"
                    onChange={e => setValues(e)}
                    value={values.email}
                  />
                </div>
                <div className="divide partOne">
                  <input
                    type="text"
                    className="inputStyles partTwo"
                    placeholder="Mobile Number *"
                    name="phoneNumber"
                    pattern="[0-9]*"
                    maxLength="10"
                    onChange={e => setValues(e)}
                    value={values.phoneNumber}
                  />
                </div>
              </div>

              <div></div>
              <div>
                <input
                  type="text"
                  className="inputStyles partTwo"
                  placeholder="Order Id *"
                  name="orderId"
                  // pattern="[0-9]*"
                  // maxLength="15"
                  onChange={e => setValues(e)}
                  value={values.orderId}
                />
              </div>
              <div className="sourceDiv">
                <div className="optionsDiv">
                  <div className="contact__date">
                    <Select
                      placeholder="Select Store *"
                      options={filteredArr}
                      value={values.store}
                      onChange={e => setValues(e, 'store')}
                      // styles={customStyles}
                    />
                  </div>
                  <div className="contact__date">
                    <Select
                      placeholder="Select Order Type *"
                      options={[
                        { value: 'Delivery', label: 'Delivery' },
                        { value: 'Dine-in', label: 'Dine-in' }
                      ]}
                      value={values.order_type}
                      onChange={e => setValues(e, 'order_type')}
                      // styles={customStyles}
                    />
                  </div>
                  {/* {values?.order_type?.label === 'Delivery' && ( */}
                  <div className="contact__date">
                    <Select
                      placeholder="Select Source *"
                      options={[
                        { value: 'BK App', label: 'BK App' },
                        { value: 'Zomato', label: 'Zomato' },
                        { value: 'Swiggy', label: 'Swiggy' },
                        { value: 'Magicpin', label: 'Magicpin' }
                      ]}
                      value={values.source}
                      isDisabled={values?.order_type?.label === 'Dine-in'}
                      onChange={e => setValues(e, 'source')}
                      // styles={customStyles}
                    />
                  </div>
                  {/* )} */}
                </div>
              </div>
              <div>
                <textarea
                  //   type="text"
                  className="inputStyles"
                  placeholder="Details *"
                  name="dis"
                  style={{
                    resize: 'none',
                    height: '10rem'
                  }}
                  onChange={e => setValues(e)}
                  value={values.dis}
                  rows="10"
                />
              </div>
              {/* {values.images.map((img, index) => ( */}
              <div className="flexed">
                <div className="flexed choose">
                  <div>
                    <p className="feedback-form__subtitle">File Upload</p>
                  </div>
                  {!values.formData && (
                    <div>
                      <Upload
                        onChange={handleFileChange}
                        accept={'.pdf, image/*'}
                      >
                        <Button
                          theme={theme}
                          content="Choose File"
                          className="myveryown_btn"
                          // onClick={() =>
                          //   document.getElementById('source').click()
                          // }
                        />
                      </Upload>
                    </div>
                  )}
                  <div>
                    <p className="feedback-form__subtitle">
                      {values?.formData?.name ?? 'No File Choosen'}
                    </p>
                  </div>
                </div>
                {values?.formData?.name && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      marginLeft: '2rem'
                    }}
                    onClick={() => onDelete()}
                  >
                    <img src={crossImage} alt="Delete" className="imgg" />
                    <span className="feedback-form__subtitle dd">Delete</span>
                  </div>
                )}
                {/* <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onClick={() => addOther()}
              >
                <img src={addImage} alt="Add" className="imgg" />
                <span className="feedback-form__subtitle dd">Add Another</span>
              </div> */}
              </div>
              {/* ))} */}
              <p className="feedback-form__note">
                <b>Note :-</b> If you have multiple attachments, combine them
                into a single PDF file and upload it.
              </p>
              <div>
                <Button
                  theme={theme}
                  content="Submit"
                  className="feedback-form__submit-btn button block is-large  ddddd"
                  onClick={() => handleSubmit()}
                />
              </div>
            </div>
          </>
        ) : (
          <div>
            <h1 className="feedback-form__title123">
              thank you for your valuable feedback.
              <br /> We appreciate it greatly!
            </h1>
          </div>
        )}

        <div className="feedback-form__submit"></div>
      </div>
    </div>
  );
  const onCloseModalHandler = () => {};
  return (
    <Modal
      isMobileFullLayout
      fullWidth
      onCloseHandler={onCloseModalHandler}
      hideClose
      width={140}
      contentCustomClass="ball"
    >
      <div className="feedback delivery">{renderContent(closeMe)}</div>
    </Modal>
  );
};

export default FeedbackLatest;
